module.exports = __webpack_public_path__ + "static/media/testImage10.ccf33529.png";